/**
 * Chat Manager Component
 *
 * Integrates idle detection with chat widget.
 * Opens chat automatically after 30 seconds of user inactivity.
 */

import React, { useState } from 'react';
import { useIdleDetection } from '../../hooks/useIdleDetection';
import { useChat } from '../../contexts/ChatContext';
import { ChatWidget } from './ChatWidget';

export const ChatManager: React.FC = () => {
  const { openChat, isOpen } = useChat();
  const [hasAutoOpened, setHasAutoOpened] = useState(false);

  useIdleDetection(() => {
    if (!hasAutoOpened && !isOpen) {
      openChat();
      setHasAutoOpened(true);
    }
  }, 30000); // 30 seconds

  return <ChatWidget />;
};
